// let backendHost = "https://test-app.getpacer.com";
// eslint-disable-next-line no-undef
let backendHost = __API_SERVER__;

// eslint-disable-next-line no-undef
if (__API_SLOT_SERVER__) {

    const hostname = window && window.location && window.location.hostname;

    if (hostname === 'prodslot-app.getpacer.com') {
        // eslint-disable-next-line no-undef
        backendHost = __API_SLOT_SERVER__;
    }

}


export const BACKEND_HOST = backendHost;
export const API_ROOT = `${backendHost}/api/`;